import dayjs from "dayjs";
import { FC } from "react";
import {
  Balloon as BalloonBase,
  Props as BalloonProps,
} from "shared/components/atoms/Balloon";
import { Logo } from "shared/components/atoms/Logo";
import { Colors } from "shared/styles";
import tw, { css } from "twin.macro";

/**
 * @param children Optional[ReactNode]
 * @param position Optional["left" | "right"] default: "right"
 * @param check Optional[boolean] default: false
 * @param date Optional[Dayjs]
 * @param classes Optional[{ root: CSSProps, balloon: CSSProps }]
 * @param className Optional[string]
 */
export const Balloon: FC<BalloonProps> = ({
  children,
  position = "left",
  date = dayjs(),
  classes,
  icon,
  ...props
}) => {
  return (
    <BalloonBase
      classes={{
        root: [classes?.root, tw`mt-[30px]`],
        balloon: [
          classes?.balloon,
          css({ background: Colors.blue["01"], color: "#070c23" }),
        ],
      }}
      position={position}
      date={date}
      renderIcon={
        !icon && (
          <div tw="bg-gradient-theme-to-l w-8 h-8 rounded-full flex-center">
            <Logo color="white" css={css({ transform: "scale(.5)" })} />
          </div>
        )
      }
      icon={icon}
      {...props}
    >
      {children}
    </BalloonBase>
  );
};
